module.exports = __webpack_public_path__ + "img/btn_menu-close.00cc79e5.png";